<template>
  <div></div
></template>

<script>
export default {
  components: {},
  created() {
    this.$helpers.Logout();
  }
};
</script>
